module.exports = "\r\niframe {\r\n\tborder: 0;\r\n\twidth: 100%;\r\n\theight: 50px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/utility/editor-display/editor-display.component.css
// module id = ./src/app/components/utility/editor-display/editor-display.component.css
// module chunks = main